import classes from './IOSSpinner.module.css';

const IOSSpinner = () => {
  return (
    <div className={classes.spinner}>
      <div className={classes.bar1}></div>
      <div className={classes.bar2}></div>
      <div className={classes.bar3}></div>
      <div className={classes.bar4}></div>
      <div className={classes.bar5}></div>
      <div className={classes.bar6}></div>
      <div className={classes.bar7}></div>
      <div className={classes.bar8}></div>
      <div className={classes.bar9}></div>
      <div className={classes.bar10}></div>
      <div className={classes.bar11}></div>
      <div className={classes.bar12}></div>
    </div>
  );
};

export default IOSSpinner;
